import { useEffect, useState } from 'react'

function useServerData<FetchedDataType, FetchArgsType>(
  fetchFunction: (args: FetchArgsType) => Promise<FetchedDataType[]>,
  fetchArgs: FetchArgsType,
  waitOnParentDependency?: boolean
) {
  const [data, setData] = useState<FetchedDataType[]>([])
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  // The dependency array of useEffect hook uses a reference compare
  // For the fetchArgs object, this means we won't trigger a change
  // properly if individual parts of the arguments are changed.
  // Use the JSON encoding of the object instead
  const fetchArgsJson = JSON.stringify(fetchArgs)

  const fetchData = async () => {
    setIsLoading(true)

    try {
      if (waitOnParentDependency) {
        setData([])
      } else {
        const fetchedData = await fetchFunction(fetchArgs)
        setData(fetchedData)
      }
    } catch (err) {
      setData([])
      setError(err)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [fetchArgsJson, waitOnParentDependency])

  return {
    data,
    error,
    fetchData,
    isLoading,
  }
}

export default useServerData
